import { type CSSProperties } from 'react';

import styles from './RatingBar.styles';

export interface RatingBarProps {
  percentage: number;
  size?: 'sm' | 'md';
}

export default function RatingBar(props: RatingBarProps) {
  const { percentage, size } = props;

  const dynamicStyles = {
    '--percentage': `${percentage}%`,
  } as CSSProperties;

  return <div className={styles({ size })} style={dynamicStyles} />;
}
